import { render } from "./BannerSlotDetail.vue?vue&type=template&id=1b873dff&scoped=true&ts=true"
import script from "./BannerSlotDetail.vue?vue&type=script&lang=ts"
export * from "./BannerSlotDetail.vue?vue&type=script&lang=ts"

import "./BannerSlotDetail.vue?vue&type=style&index=0&id=1b873dff&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b873dff"]])

export default __exports__